/* BEGIN TFX_CART_QTY_STEP
   Objectif : un abonnement « Qté = nb de mois » (ex. trimestriel = 3 unités) ne se modifie
   dans le panier que par multiples du pas (3, 6, 9… ; 0 = suppression).
   Scope : champs .cart-item__quantity-input[data-tfx-qty-step] (snippets/cart-item.liquid).
   Pourquoi un script : le thème (main.js, CartForm) fait `valeur += input.step`, attribut texte,
   donc « 3 » + « 3 » = « 33 ». On gère +/− ici et on laisse le thème envoyer la mise à jour
   (événement change, chemin « currentValue » de CartForm).
   TFX_B2B_QTY (panier) : clients pros, data-tfx-qty-min = minimum du catalogue. Valeurs autorisées :
   min, min + pas, min + 2 pas… ; « − » sans effet au minimum (0 seulement via « Supprimer » ou saisie de 0).
   Sans ce script : comportement d'origine du thème (pas de 1).
   Rollback : supprimer ce fichier, son include dans layout/theme.liquid et le bloc TFX_CART_QTY_STEP de cart-item.liquid.
*/
(function () {
  'use strict';
  if (window.__tfxCartQtyStepInstalled) return;
  window.__tfxCartQtyStepInstalled = true;

  function stepOf(input) {
    var step = parseInt(input && input.getAttribute('data-tfx-qty-step'), 10);
    if (minOf(input)) return step > 0 ? step : 1;
    return step > 1 ? step : 0;
  }

  // TFX_B2B_QTY (panier) : minimum du catalogue pro (0 = pas de minimum).
  function minOf(input) {
    var min = parseInt(input && input.getAttribute('data-tfx-qty-min'), 10);
    return min > 0 ? min : 0;
  }

  // Plus grande valeur autorisée <= max (grille min + k x pas).
  function capB2b(max, min, step) {
    return min + Math.floor((max - min) / step) * step;
  }

  // Boutons + / − : on remplace l'action du thème pour les lignes concernées uniquement.
  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('.quantity-up, .quantity-down') : null;
    if (!btn) return;
    var item = btn.closest('.cart-item');
    var input = item ? item.querySelector('.cart-item__quantity-input[data-tfx-qty-step]') : null;
    var step = stepOf(input);
    if (!step) return;

    evt.preventDefault();
    evt.stopPropagation();
    if (btn.classList.contains('unusable')) return;

    var current = parseInt(input.value, 10) || 0;
    var min = minOf(input);
    if (min) {
      var up = btn.classList.contains('quantity-up');
      var nextB2b = up
        ? (current < min ? min : min + (Math.floor((current - min) / step) + 1) * step)
        : (current <= min ? current : min + (Math.ceil((current - min) / step) - 1) * step);
      var maxB2b = parseInt(input.getAttribute('max'), 10);
      if (Number.isFinite(maxB2b) && nextB2b > maxB2b) return;
      if (nextB2b === current) return;
      input.value = String(nextB2b);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var next = btn.classList.contains('quantity-up')
      ? (Math.floor(current / step) + 1) * step
      : Math.max(0, (Math.ceil(current / step) - 1) * step);
    var max = parseInt(input.getAttribute('max'), 10);
    if (Number.isFinite(max) && next > max) return;

    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  // Saisie manuelle : arrondi au multiple supérieur (2 -> 3, 4 -> 6 ; 0 = suppression),
  // avant que le thème n'envoie la mise à jour.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('.cart-item__quantity-input[data-tfx-qty-step]')) return;
    var step = stepOf(input);
    if (!step) return;
    var value = parseInt(input.value, 10);
    if (!Number.isFinite(value) || value < 0) value = 0;
    var min = minOf(input);
    if (min) {
      // 0 = suppression ; sinon ramené au minimum, puis au palier de pas supérieur, dans la limite du max.
      var v = value === 0 ? 0 : (value < min ? min : min + Math.ceil((value - min) / step) * step);
      var maxB2b = parseInt(input.getAttribute('max'), 10);
      if (v && Number.isFinite(maxB2b) && v > maxB2b) v = capB2b(maxB2b, min, step);
      if (String(v) !== input.value) input.value = String(v);
      return;
    }
    var rounded = Math.ceil(value / step) * step;
    var max = parseInt(input.getAttribute('max'), 10);
    if (Number.isFinite(max) && rounded > max) rounded = Math.floor(max / step) * step;
    if (String(rounded) !== input.value) input.value = String(rounded);
  }, true);
})();
/* END TFX_CART_QTY_STEP */

/* BEGIN TFX_APPSTLE_CROSS_ADD_GUARD
   Problème : le widget Appstle (fiche produit) intercepte fetch et ajoute le plan d'abonnement
   coché à TOUT ajout panier, y compris « Pour compléter » du tiroir ou les ajouts rapides
   d'autres produits -> erreur Shopify « Impossible d'appliquer le forfait de vente à la variante ».
   Correctif : pour un ajout d'un produit AUTRE que celui de la fiche, le choix « Abonnement » est
   masqué à Appstle pendant l'appel (décoché puis recoché aussitôt, sans événement).
   L'ajout du produit de la fiche garde le comportement Appstle d'origine.
   Rollback : supprimer ce bloc.
*/
(function () {
  'use strict';
  if (window.__tfxAppstleGuardInstalled) return;
  window.__tfxAppstleGuardInstalled = true;

  var PLAN_SELECTOR = '.appstle_sub_widget input[name="selling_plan"]:checked';

  function pageVariantIds() {
    var product = window.RSConfig && window.RSConfig.product;
    if (!product || !product.variants || !product.variants.length) return null;
    return product.variants.map(function (v) { return String(v.id); });
  }

  // Variante ajoutée : FormData (formulaires du thème) ou objet JSON { id, quantity }.
  // Les envois { items: [...] } ne sont pas concernés (Appstle ne modifie que la variante de la fiche).
  function addedVariantId(body) {
    if (!body) return '';
    if (typeof FormData !== 'undefined' && body instanceof FormData) return String(body.get('id') || '');
    if (typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data && !Array.isArray(data.items) && data.id) return String(data.id);
      } catch (e) {}
    }
    return '';
  }

  // Chaque installation crée son propre wrapper (pas d'état partagé) : aucune boucle possible
  // même si Appstle ré-enveloppe fetch après nous.
  function makeGuard(inner) {
    var guard = function (input, init) {
      var radio = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1) {
          var id = addedVariantId(init && init.body);
          var ids = pageVariantIds();
          var checked = document.querySelector(PLAN_SELECTOR);
          if (id && ids && ids.indexOf(id) === -1 && checked && checked.value) {
            radio = checked;
            radio.checked = false;
          }
        }
      } catch (e) {
        radio = null;
      }
      try {
        return inner.apply(this, arguments);
      } finally {
        if (radio) radio.checked = true;
      }
    };
    guard.__tfxAppstleGuard = true;
    return guard;
  }

  // Appstle remplace window.fetch à son chargement : on se replace en premier appelant
  // si besoin, avant chaque interaction (et au chargement complet de la page).
  function ensureOutermost() {
    if (typeof window.fetch !== 'function' || window.fetch.__tfxAppstleGuard) return;
    window.fetch = makeGuard(window.fetch);
  }
  ensureOutermost();
  window.addEventListener('load', ensureOutermost);
  document.addEventListener('pointerdown', ensureOutermost, true);
  document.addEventListener('keydown', ensureOutermost, true);
  document.addEventListener('submit', ensureOutermost, true);
})();
/* END TFX_APPSTLE_CROSS_ADD_GUARD */

/* BEGIN TFX_APPSTLE_COMPARE_LOADER
   Charge assets/tfx-appstle-compare.js (prix barré du widget Appstle + montant du bouton) sur les fiches produit.
   Template produit-nutraceutique-abo inclus (TFX_APPSTLE_COMPARE_ABO_MULTI, 04/10/2026) : tfx-appstle-compare.js
   ignore lui-même les fiches où tfx-abo-qty est actif ([data-tfx-abo-qty], produits à variante unique). Même dossier d'assets que ce fichier. Après toute modification de tfx-appstle-compare.js,
   incrémenter APC_VERSION (vide le cache du CDN).
   Rollback : supprimer ce bloc.
*/
(function () {
  'use strict';
  var APC_VERSION = '13';
  var self = document.currentScript;
  var bc = document.body && document.body.classList;
  if (!self || !self.src || !bc || !bc.contains('template-product')) return;
  var el = document.createElement('script');
  el.src = self.src.split('?')[0].replace(/tfx-cart-qty-step\.js$/, 'tfx-appstle-compare.js') + '?v=' + APC_VERSION;
  el.defer = true;
  document.head.appendChild(el);
})();
/* END TFX_APPSTLE_COMPARE_LOADER */

/* BEGIN TFX_APPSTLE_PRICE_NOWRAP
   Widget Appstle : prix + prix barré toujours sur une seule ligne (mobile : « € 51 € » / « 57 » sinon).
   Le libellé « Abonnement » + badge se resserre à la place. Toutes pages (widget aussi possible en achat rapide).
   Rollback : supprimer ce bloc.
*/
(function () {
  'use strict';
  if (document.getElementById('tfx-appstle-nowrap')) return;
  var st = document.createElement('style');
  st.id = 'tfx-appstle-nowrap';
  st.textContent = '.appstle_subscription_amount_wrapper,.appstle_one_time_price_wrapper{white-space:nowrap;flex-shrink:0;}';
  (document.head || document.documentElement).appendChild(st);
})();
/* END TFX_APPSTLE_PRICE_NOWRAP */

/* BEGIN TFX_CART_DRAWER_NARROW
   Tiroir panier, petits écrans (ex. 320 px) : une ligne en abonnement débordait à droite (~13 px), le prix sortait
   de l'écran. Cause : bloc texte de la ligne en flex avec min-width:auto + étiquette du plan
   (« Trimestriel sans engagement -15% ») et « unités par expédition » en white-space:nowrap.
   Correctif : le bloc peut rétrécir, l'étiquette et la mention passent à la ligne seulement si la place manque
   (aucun changement visible quand la largeur suffit). Tiroir uniquement (.cart-drawer).
   Rollback : supprimer ce bloc.
*/
(function () {
  'use strict';
  if (document.getElementById('tfx-cart-drawer-narrow')) return;
  var st = document.createElement('style');
  st.id = 'tfx-cart-drawer-narrow';
  st.textContent = '.cart-drawer .cart-item__not-image{min-width:0;}' +
    '.cart-drawer .cart-item__item-discounts .cart-discount--inline{max-width:100%;}' +
    '.cart-drawer .cart-item__item-discounts .cart-discount__label{white-space:normal;}' +
    '.cart-drawer .tfx-cart-qty-step{flex-wrap:wrap;row-gap:4px;}';
  (document.head || document.documentElement).appendChild(st);
})();
/* END TFX_CART_DRAWER_NARROW */
